import { all, fork } from 'redux-saga/effects'

// admin
import admin from '@redux/saga/admin/admin.saga'
import adminUsers from '@redux/saga/admin/adminUsers.saga'
import accessControl from '@redux/saga/admin/accessControl.saga'
// @PLOP-IMPORTS

export default function* rootSaga() {
	yield all([
		fork(admin),
		fork(adminUsers),
		fork(accessControl),
		// @PLOP-CODE
	])
}
